import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../../../DevilsCrossRoad";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DevilsCrossRoadGameMode} from "../../../server/DevilsCrossRoadGameMode";
import {gsap} from "gsap";


export class RightTwo implements SimplePresentationRunner {

    private _mainTl:gsap.core.Timeline;
    private _isFeature:boolean = false;

    shouldRun():boolean {
        this._isFeature = DevilsCrossRoad.model.data.featureTable[5][2];
        return (this._isFeature && DevilsCrossRoad.model.gameData.mode == GameMode.FREESPIN || DevilsCrossRoad.model.gameData.mode == DevilsCrossRoadGameMode.SUPER_FREESPIN);
    }

    start(controller: SimplePresentationRunnerController): void {
        this._mainTl = gsap.timeline();
        const featureId: string = DevilsCrossRoad.model.data.stickyCoins[5][2];
        const activationIndex: number = 1;

        controller.setSkipCallback(() => this.skip(controller));

        const rowIndexes: number [][] = [
            [1, 7, 13, 19, 25],
            [2, 8, 14, 20, 26],
            [3, 9, 15, 21, 27],
            [4, 10, 16, 22, 28],
            [5, 11, 17, 23, 29]
        ];

     if(this._isFeature && ["F2", "F4", "F5", "F6"].indexOf(featureId) > -1) {
            let targetPosition: number = -1;

            const flatTargets: number [] = DevilsCrossRoad.model.featureClientFlattenedTargetIndex;
            rowIndexes[1].forEach((idxToCheck) => {
                if(flatTargets[idxToCheck] > -1) {
                    targetPosition = idxToCheck;
                }
            });

            this._mainTl.add(DevilsCrossRoad.cashFeatureHandler.getRightEyeTimeline(featureId, activationIndex, targetPosition));
        }
        else if(this._isFeature) {
            this._mainTl.add(DevilsCrossRoad.cashFeatureHandler.getRightEyeTimeline(featureId, activationIndex));
        }

        this._mainTl.add(() => controller.finish());
    }

    private skip(controller:SimplePresentationRunnerController):void{
        this._mainTl.totalProgress(1);
    }
}